import { useRouter } from 'next/router'
import { useState, useLayoutEffect } from 'react'

const useLocalStorage = (localStorageName: string): boolean => {
  const router = useRouter()

  const [fromCorrectFormPage, setFromCorrectFormPage] = useState<boolean>(false)

  // リダイレクト時にサンクスページがチラつくためuseLayoutEffectを使用
  useLayoutEffect(() => {
    const fromDownloadPage: string | null = localStorage.getItem(localStorageName)
    if (fromDownloadPage) {
      setFromCorrectFormPage(true)
    } else {
      setFromCorrectFormPage(false)
      router.push('/')
    }
  }, [])

  return fromCorrectFormPage
}

export default useLocalStorage
